import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5073a3e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  style: {"flex":"1"},
  "data-test": "slotwrapper"
}
const _hoisted_2 = {
  key: 0,
  class: "close_btn__wrapper"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    "data-test": "alert",
    role: "alert",
    class: _normalizeClass(["alert", {
      [_ctx.mode]: true,
      [_ctx.variant]: true,
      dismissable: !!_ctx.dismiss,
      with_icon: _ctx.icon,
    }])
  }, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.icon), {
      "aria-label": _ctx.mode + ' icon',
      class: "alert_icon"
    }, null, 8, ["aria-label"])),
    _createElementVNode("span", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    (!!_ctx.dismiss)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("button", {
            class: "close_btn",
            "aria-label": "close warning",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.dismiss && _ctx.dismiss(...args))),
            "data-test": "alert-dismiss-btn"
          }, " × ")
        ]))
      : _createCommentVNode("", true)
  ], 2))
}